import { Component, OnInit } from '@angular/core';
import { Router }            from '@angular/router';
import {Location}           from '@angular/common';
import { ApplicationContextService }         from './app-context.service';
import {ColorMode }         from './app-context.service';
import { PriceItem }                from './priceitem';
import { PriceListService }         from './pricelist.service';


@Component({
  // moduleId: module.id,
   selector: 'pricelist-detail',
  templateUrl: './pricelist-detail.component.html',
  styleUrls: ['./content-detail.component.css','./pricelist-detail.component.css' ]
})
export class PricelistDetailComponent implements OnInit {

  pricelist: PriceItem[];
  selectedPriceItem: PriceItem;
errorMessage: string;

  constructor(
     private appContextService: ApplicationContextService,
     private location: Location,
    private pricelistService: PriceListService,
    private router: Router) { }


 getPriceList() {
  this.pricelistService.getPriceList()
                   .then(
                     pricelist => this.pricelist = pricelist,
                     error =>  this.errorMessage = <any>error);
  console.log(this.pricelist);
}


  // add(name: string): void {
  //   name = name.trim();
  //   if (!name) { return; }
  //   this.pricelistService.create(name)
  //     .then(priceitem => {
  //       this.pricelist.push(priceitem);
  //       this.selectedPriceItem = null;
  //     });
  // }

  // delete(priceitem: PriceItem): void {
  //   this.pricelistService
  //       .delete(priceitem.id)
  //       .then(() => {
  //         this.pricelist = this.pricelist.filter(h => h !== priceitem);
  //         if (this.selectedPriceItem === priceitem) { this.selectedPriceItem = null; }
  //       });
  // }

  ngOnInit(): void {

     this.appContextService.SetMode(ColorMode.White);
      this.getPriceList();
      this.appContextService.SetURL(this.router.url);
      this.appContextService.SetSubject("Ceník"); 
 
  }

  onSelect(priceitem: PriceItem): void {
    this.selectedPriceItem = priceitem;
  }

   goBack(): void {
    this.location.back();
  }

  // gotoDetail(): void {
  //   this.router.navigate(['/detail', this.selectedHero.id]);
  // }
   gotoDetail(priceitem: PriceItem): void {
    let link = ['/detail', priceitem.id];
    this.router.navigate(link);
  }
}
